import {
    HttpClient,
    HttpEvent,
    HttpEventType,
    HttpProgressEvent,
    HttpResponse
} from '@angular/common/http';
import { concat, delay, filter, firstValueFrom, map, shareReplay, takeWhile } from 'rxjs';

import { IMAGE_UPLOAD_EXT_MIME_TYPES } from '@flb/common/image-upload-ext-mimetypes';

export function imageUpload(http: HttpClient, extensions: string[], f: File, path: string) {
    const ext = f.name.toLowerCase().replace(/.*\.(\w+)$/, '$1');
    const filename = f.name.replace(/\.\w+$/, '');
    const mimeType: string | undefined = (
        IMAGE_UPLOAD_EXT_MIME_TYPES as { [key: string]: string | undefined }
    )[ext];
    if (!extensions.includes(ext) || !mimeType) {
        throw new Error(
            `Unable to upload image with extension ${ext} (${mimeType || 'unknown mime-type'})`
        );
    }
    const request = http
        .post<{ url: string }>(`/api/storage/${path}`, f, {
            reportProgress: true,
            observe: 'events',
            headers: {
                'Content-Type': mimeType,
                'Content-Disposition': `attachment; filename="${filename}"`
            }
        })
        .pipe(shareReplay({ refCount: true }));
    return concat(
        request.pipe(
            filter(isSentEvent),
            map(evt => (evt.total ? evt.loaded / evt.total : 0))
        ),
        // add delay() to ensure that the progress bar sticks on the screen long enough to notice it
        firstValueFrom(request.pipe(filter(isFinishEvent), delay(1500))).then(r =>
            r.body ? r.body.url : 'Error, no body'
        )
        // auto-close the observable when we get the url at the end
    ).pipe(takeWhile(v => typeof v !== 'string', true));
    function isSentEvent(evt: HttpEvent<any>): evt is HttpProgressEvent {
        return evt.type === HttpEventType.UploadProgress;
    }
    function isFinishEvent(evt: HttpEvent<any>): evt is HttpResponse<{ url: string }> {
        return evt.type === HttpEventType.Response;
    }
}
